import React, { useState } from 'react'
import TutorialCard from '../../Dashboard/Components/TutorialCard'
import TutorialModal from '../../Dashboard/Components/TutorialModal'
import { Container, Row, Col } from 'react-bootstrap'

export default function TutorialsPage({ currentUser }) {
  const [currentTutorial, setCurrentTutorial] = useState('')
  const [showTutorialModal, setShowTutorialModal] = useState(false)

  const handleShowTutorial = (tutorial) => {
    setCurrentTutorial(tutorial)
    setShowTutorialModal(true)
  }
  
  const handleHideTutorial = () => {
    setShowTutorialModal(false)
  }

  return (
    <Container>
      <TutorialModal 
        show={showTutorialModal} 
        tutorial={currentTutorial} 
        handleClose={handleHideTutorial}
      />
      <Row className='my-4 text-center'>
        <Col>
          <h2 className='font-weight-light'>How-To Tutorial Videos</h2>
        </Col>
      </Row>
      <Row>
        <Col className='lead text-center'>
          Click on one of the tutorial links below to view a how-to video.
        </Col>
      </Row>
      <Row className='my-5'>
        <Col>
          <Row className='mb-3'>
            <Col>
              <TutorialCard 
                icon={<i className="far fa-file-alt fa-sm text-light"></i>}
                title='Forms'
                tutorials={[
                  { id: 1, link: 'https://www.youtube.com/embed/cnqBOrnMhgg', title: 'How to send a form' },
                  { id: 2, link: 'https://www.youtube.com/embed/-II4OYYzIzU', title: 'How to view a form' },
                  { id: 3, link: 'https://www.youtube.com/embed/qHoIvQuPuQQ', title: 'How to cancel a form' },
                  { id: 4, link: 'https://www.youtube.com/embed/0yjnnoVjd58', title: 'How to resend a form' },
                  { id: 5, link: 'https://www.youtube.com/embed/EoW8ZJCjb7Q', title: 'How to download a form' },
                  { id: 6, link: 'https://www.youtube.com/embed/3yUE5cpl8hM', title: 'How to export form data' },
                  { id: 7, link: 'https://www.youtube.com/embed/9sPNXz44I_E', title: 'How to reschedule a form' },
                ]}
                showTutorial={handleShowTutorial}
              />
            </Col>
            <Col>
              <TutorialCard 
                icon={<i className="fas fa-laptop-medical fa-sm text-light"></i>}
                title='Telehealth'
                tutorials={[
                  { id: 1, link: '', title: 'How to send a care plan (NEED VID)' },
                  { id: 2, link: 'https://www.youtube.com/embed/9qXm57pJuZc', title: 'How to start a video telehealth' },
                  { id: 3, link: 'https://www.youtube.com/embed/b74G_siy4NQ', title: 'How to cancel a telehealth appointment' },
                  { id: 4, link: 'https://www.youtube.com/embed/A20EF280Ngg', title: 'How to send a message through telehealth' },
                  { id: 5, link: 'https://www.youtube.com/embed/giIi28vS2O0', title: 'How to schedule a telehealth appointment' },
                  { id: 6, link: 'https://www.youtube.com/embed/_1p9QD-kI9k', title: 'How to view telehealth pre-visit questions'},
                  { id: 7, link: 'https://www.youtube.com/embed/aiilRA62mSM', title: 'How to reschedule a telehealth appointment'},
                  { id: 8, link: 'https://www.youtube.com/embed/sOUHL9uFono', title: 'How to resend telehealth pre-visit questions' },
                  { id: 9, link: 'https://www.youtube.com/embed/mBNdVagC3jE', title: 'How to download telehealth pre-visit questions'},
                ]}
                showTutorial={handleShowTutorial}
              />
            </Col>
          </Row>
          <Row className='my-4'>
            <Col>
              <TutorialCard 
                icon={<i className="far fa-calendar-alt fa-sm text-light"></i>}
                title='Events'
                tutorials={[
                  { id: 1, link: 'https://www.youtube.com/embed/PoDdM5XP_3U', title: 'How to view an event' },
                  { id: 3, link: 'https://www.youtube.com/embed/CHCV3ub5C_0', title: 'How to cancel an event' },
                  { id: 2, link: 'https://www.youtube.com/embed/_U-1QhkRwEk', title: 'How to schedule an event' },
                  { id: 4, link: 'https://www.youtube.com/embed/iLTPio7a8r0', title: 'How to reschedule an event' },
                  { id: 5, link: 'https://www.youtube.com/embed/_YQAGti5FqE', title: 'How to add a form or telehealth appointment to an event' },
                ]}
                showTutorial={handleShowTutorial}
              />
            </Col>
            <Col>
              <TutorialCard 
                icon={<i className="far fa-comment-dots fa-sm text-light" aria-hidden="true"></i>}
                title='Messages'
                tutorials={[
                  { id: 1, link: 'https://www.youtube.com/embed/6Yd9G2gxQPE', title: 'How to notify a provider' },
                  { id: 2, link: 'https://www.youtube.com/embed/vPeKiAo_G4I', title: 'How to end a conversation' },
                  { id: 3, link: 'https://www.youtube.com/embed/wE3CVpj9sIk', title: 'How to send a patient messsage' },
                  { id: 4, link: 'https://www.youtube.com/embed/7qau0UJeDDg', title: 'How to toggle notification settings' },
                  { id: 5, link: 'https://www.youtube.com/embed/JV2tvMMCWCU', title: 'How to search for a patient message' },
                  { id: 6, link: 'https://www.youtube.com/embed/TK1dU9lsm84', title: 'How to add a participant to a message' },
                ]}
                showTutorial={handleShowTutorial}
              />
            </Col>
          </Row>
          <Row>
            <Col xs='6'>
              <TutorialCard 
                icon={<i className="fa fa-filter fa-sm text-light" aria-hidden="true"></i>}
                title='Intake'
                tutorials={[
                  { id: 5, title: 'How to use a form through Intake (NEED VID)' }
                ]}
                showTutorial={handleShowTutorial}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  )
}
